(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name crewProfile.controller:layoverAccommodationPreferenceEditCtrl
	 *
	 * @description
	 *
	 */
	angular.module('crewProfile').controller('layoverAccommodationPreferenceEditCtrl',
			layoverAccommodationPreferenceEditCtrl);

	function layoverAccommodationPreferenceEditCtrl($uibModalInstance, modalParams, ProfileService,
			MessageService, EventManagerService, CommonMasterData) {
		var vm = this;
		vm.ctrlName = 'layoverAccommodationPreferenceEditCtrl';
		vm.selectedRowBeforeUpdate = angular.copy(modalParams.selectedRow);
		vm.model = {
			selectedPreferenceData : adaptPreferenceData(),
			masterList : {
			  airportList: modalParams.masterList.stations || []
			},
			fromDateAfterToDate : false
		};

		function adaptPreferenceData() {
      if(vm.selectedRowBeforeUpdate.station != ''){
        vm.selectedRowBeforeUpdate.station = selectStationFromList(
                					vm.selectedRowBeforeUpdate.station,
                					modalParams.masterList.stations);
      }
      if(vm.selectedRowBeforeUpdate.validFromDate != ''){
        vm.selectedRowBeforeUpdate.fromDate = vm.selectedRowBeforeUpdate.validFromDate;
      }
      if(vm.selectedRowBeforeUpdate.validToDate != ''){
        vm.selectedRowBeforeUpdate.toDate = vm.selectedRowBeforeUpdate.validToDate;
      }
      if(vm.selectedRowBeforeUpdate.hotelNotReq != ''){
        vm.selectedRowBeforeUpdate.hotelNotReq = (vm.selectedRowBeforeUpdate.hotelNotReq === 'Y');
      }

			return angular.copy(vm.selectedRowBeforeUpdate);
		}
		;

		function selectStationFromList(station, list) {
      if (!!station && !!list) {
        return _.find(list, {
          airPortCode : station
        });
      }
      return null;
    }
    ;


		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.selectedPreferenceData.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.selectedPreferenceData.fromDate,
									"DD/MM/YYYY"));
		}
		;

		vm.changeField = function(flag) {
			if (flag == 'fromDate') {
				var tempFromDate = moment(vm.model.selectedPreferenceData.fromDate,
						"DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
				vm.model.selectedPreferenceData.toDate = tempFromDate;
			}
			if (!isDateFormatInvalid(vm.model.selectedPreferenceData.fromDate)
					&& !isDateFormatInvalid(vm.model.selectedPreferenceData.toDate)) {
				vm.model.fromDateAfterToDate = istoDateBeforeFromDate();
			} else {
				vm.model.fromDateAfterToDate = false;
			}
		};

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}
		;

		function getSavePreferenceRequest(preferenceDTO) {
			var req = {};
			req.fromDate = preferenceDTO.fromDate;
			req.toDate = preferenceDTO.toDate;
			req.station = preferenceDTO.station.airPortCode;
			req.remarks = preferenceDTO.remarks;
			req.crewProfileId = preferenceDTO.crewProfileId;
			req.hotelNotReq = preferenceDTO.hotelNotReq;
			req.crewLayoverAccommodationPrefId = preferenceDTO.crewLayoverAccommodationPrefId;
			req.version = preferenceDTO.version;
			return req;
		}



		vm.saveUpdatePreference = function(preferenceDTO) {
			vm.layoverAccommodationPreferenceForm.$submitted = true;
			vm.model.fromDateAfterToDate = istoDateBeforeFromDate();
			if (isValidSelectedPreferenceData()) {
				var param = getSavePreferenceRequest(preferenceDTO);
				ProfileService
						.savePreferenceData(
								param,
								function(response) {
									if (response.success) {
										MessageService
												.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
										vm.onCloseClick();
									}
								}, function(error) {
									MessageService.error(error);
								});
			}
		};

		function isValidSelectedPreferenceData() {
			if (vm.layoverAccommodationPreferenceForm.$valid
					&& vm.model.selectedPreferenceData.station.airPortCode !== ''
					&& !vm.model.fromDateAfterToDate) {
				return true;
			}
			return false;
		}

		(function() {
      // airportList
      CommonMasterData.getAirportList(function(airportList) {
        vm.model.masterList.airportList = airportList;
      }, function() {
        console.log('Airport List retrieval error');
      });


    })();

		vm.onCloseClick = function() {
			$uibModalInstance.close(modalParams.close);
		};

	}
}());
